const refreshHandlers = {};

export function registerUndoRefreshHandler(entity, handler) {
	if (!entity) {
		return;
	}
	if (handler) {
		refreshHandlers[entity] = handler;
	} else {
		delete refreshHandlers[entity];
	}
}

export function runUndoRefresh(command) {
	if (!command?.entity) {
		return;
	}

	const handler = refreshHandlers[command.entity];
	if (handler) {
		handler(command.refresh || {});
	}
}
